<template>
  <div id="app">
    <Header></Header>
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import Vue from "vue";
import Footer from "./components/footer";
import Header from "./components/header";
// import checkHost from "../public/host";
export default {
  name: "App",
  components: {
    Footer,
    Header,
  },

  mounted() {
    // const beian = checkHost(window.location.host);
    // const beian = localStorage.getItem("beian");
    // document.title = JSON.parse(beian).title;
    document.title = "推精灵 - 广州言成科技有限公司";
    document.body.classList.add("home");
  },
};
</script>

<style lang="less">
* {
  padding: 0;
  margin: 0;
  font-family: Microsoft YaHei, Nespresso Lucas, Roboto, sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #1d2129;
  font-style: normal;
  // letter-spacing: 2px;
  box-sizing: border-box;
}

body,
html {
  // overflow-x: hidden;
  // max-width: 1200px;
  background-color: #fff;
}

a {
  color: #1d2129;
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  -webkit-user-select: none;
  user-select: none;
  -moz-user-focus: none;
  -moz-user-select: none;
  cursor: pointer;
}
img {
  width: 100%;
  vertical-align: top;
}

ul,
li {
  list-style: none;
}

.line1 {
  // overflow: hidden;
  // text-overflow: ellipsis;
  // white-space: nowrap;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.line2 {
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.line3 {
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.w {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

.w1 {
  width: 1600px;
  margin: 0 auto;
}

.breadcrumb {
  padding: 0 150px;
  font-size: 18px;
  box-sizing: border-box;

  span {
    color: #252525;
    font-weight: 500;
    font-size: 20px;
  }
}

.nav-tab,
.nav-tab1 {
  position: absolute;
  top: 100px;
  left: 0;
  width: 100%;
  padding: 0 100px;
  height: 60px;
  background-color: rgba(23, 23, 23, 0.8);
  z-index: 999;
  display: none;

  .active {
    font-weight: 500;
    color: #fff !important;
  }

  .container {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .tab-item {
    margin-right: 200px;
    font-size: 18px;
    color: #949494;
    height: 100%;
    display: flex;
    align-items: center;

    &:hover {
      color: #fff;
    }

    // a.router-link-exact-active {
    //   background-color: orange;
    //   color: #fff;
    // }
  }
}

.section-bg {
  width: 100%;
}

body {
  transition: all 0.3s ease-out 0s;
}

.home {
  // transform: translateX(0%);
}

.navbar-on {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  transform: translateX(80%);
}

.body-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(23, 23, 23, 0.8);
  z-index: 9999999999;
  display: none;
  transition: all 0.3s ease-out 0s;
}

.viewer-open {
  padding-right: 0 !important;
}
</style>
